import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { GuestGateModal } from '@/components/GuestGateModal';

interface GuestGatePageProps {
  children: React.ReactNode;
  actionLabel: string;
}

/**
 * Wraps a page so that if the user is not logged in,
 * the page content is shown but a GuestGateModal is immediately displayed.
 */
export function GuestGatePage({ children, actionLabel }: GuestGatePageProps) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 spinner-gradient" />
      </div>
    );
  }

  if (!user) {
    return (
      <GuestGateModal
        visible={true}
        onClose={() => navigate(-1)}
        onLogin={() => navigate('/auth?redirect=' + encodeURIComponent(window.location.pathname))}
        actionLabel={actionLabel}
      />
    );
  }

  return <>{children}</>;
}
